// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".p-button-sm[data-v-cb4bd2ac]{height:35px;width:35px;font-size:.875rem;padding:.7rem}.p-component[data-v-cb4bd2ac]:disabled,.p-disabled[data-v-cb4bd2ac]{opacity:.8}.p-dropdown[data-v-cb4bd2ac]{min-width:200px}.p-dropdown-content-image[data-v-cb4bd2ac]{width:75px;height:75px;padding:10px}.p-dropdown-content-image-preview[data-v-cb4bd2ac]{width:120px;height:120px}", ""]);
// Exports
module.exports = exports;
